"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ONGOING_EVENTS_FROM_NOW = exports.GET_NEXT_EVENT_FROM_NOW = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var date_helpers_1 = require("./date.helpers");
exports.GET_NEXT_EVENT_FROM_NOW = function (events, now) {
    if (now === void 0) { now = date_helpers_1.GET_TIME_NOW(); }
    var NEXT_EVENT = events
        .sort(function (a, b) { return date_helpers_1.GET_TIME(a.start).unix() - date_helpers_1.GET_TIME(b.start).unix(); })
        .find(function (event) { return dayjs_1.default(event.start).isAfter(now) && dayjs_1.default(event.start).isSame(now, 'week'); });
    return !!NEXT_EVENT ? NEXT_EVENT : null;
};
exports.GET_ONGOING_EVENTS_FROM_NOW = function (events, now) {
    if (now === void 0) { now = date_helpers_1.GET_TIME_NOW(); }
    var NEXT_EVENTS = events.filter(function (event) {
        return date_helpers_1.GET_TIME(event.start).isBefore(now) && date_helpers_1.GET_TIME(event.end).isAfter(now);
    });
    return NEXT_EVENTS.length ? NEXT_EVENTS : null;
};
